// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay to cover the entire screen */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent black */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
}

/* Loader (spinner) */
.loader {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #ffd700; /* Blue spinner */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Keyframes for spinner animation */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.dots-7 {
  width: 12px;
  aspect-ratio: 1;
  border-radius: 50%;
  box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 5px, 38px 0 0 5px, 57px 0 0 5px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px;
  /* transform: translateX(322px); */
  animation: d6 2s infinite linear;
  color: #ffd700;
  display: flex;
  margin-left: 45vw;
  margin-top: 5vw;
  justify-content: center;
  /* text-align: center; */
}


.dots-7 {
  width: 12px;
  aspect-ratio: 1;
  border-radius: 50%;
  box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 5px, 38px 0 0 5px, 57px 0 0 5px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px;
  animation: d6 2s infinite linear;
  color: #ffd700;
  margin: auto;
}



@keyframes d6 {
  0%    { box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 5px, 38px 0 0 5px, 57px 0 0 5px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px; }
  50%   { box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 0px, 38px 0 0 0px, 57px 0 0 0px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px; }
  100%  { box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 5px, 38px 0 0 5px, 57px 0 0 5px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/layout/Loader/Loader.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,2BAA2B;EAC3D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B,EAAE,iBAAiB;EAChD,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,oCAAoC;AACpC;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,6JAA6J;EAC7J,kCAAkC;EAClC,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,wBAAwB;AAC1B;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,6JAA6J;EAC7J,gCAAgC;EAChC,cAAc;EACd,YAAY;AACd;;;;AAIA;EACE,QAAQ,6JAA6J,EAAE;EACvK,QAAQ,6JAA6J,EAAE;EACvK,QAAQ,6JAA6J,EAAE;AACzK","sourcesContent":["/* Overlay to cover the entire screen */\r\n.overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(0, 0, 0, 0.5); /* Semi-transparent black */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 999999;\r\n}\r\n\r\n/* Loader (spinner) */\r\n.loader {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 5px solid #f3f3f3;\r\n  border-top: 5px solid #ffd700; /* Blue spinner */\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n/* Keyframes for spinner animation */\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n\r\n.dots-7 {\r\n  width: 12px;\r\n  aspect-ratio: 1;\r\n  border-radius: 50%;\r\n  box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 5px, 38px 0 0 5px, 57px 0 0 5px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px;\r\n  /* transform: translateX(322px); */\r\n  animation: d6 2s infinite linear;\r\n  color: #ffd700;\r\n  display: flex;\r\n  margin-left: 45vw;\r\n  margin-top: 5vw;\r\n  justify-content: center;\r\n  /* text-align: center; */\r\n}\r\n\r\n\r\n.dots-7 {\r\n  width: 12px;\r\n  aspect-ratio: 1;\r\n  border-radius: 50%;\r\n  box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 5px, 38px 0 0 5px, 57px 0 0 5px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px;\r\n  animation: d6 2s infinite linear;\r\n  color: #ffd700;\r\n  margin: auto;\r\n}\r\n\r\n\r\n\r\n@keyframes d6 {\r\n  0%    { box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 5px, 38px 0 0 5px, 57px 0 0 5px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px; }\r\n  50%   { box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 0px, 38px 0 0 0px, 57px 0 0 0px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px; }\r\n  100%  { box-shadow: 19px -19px 0 0px, 38px -19px 0 0px, 57px -19px 0 0px, 19px 0 0 5px, 38px 0 0 5px, 57px 0 0 5px, 19px 19px 0 0px, 38px 19px 0 0px, 57px 19px 0 0px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
